import React, { useEffect, useState } from "react";
import { Header, Sidebar } from '../Layout';
import { Link } from "react-router-dom";
import { getAdminDashboardProjects } from "../../../actions/adminActions";
import { useSelector, useDispatch } from "react-redux";
import DataTablesProject from "./DataTablesProject";

const ActivitySchedule = () => {
    const dispatch = useDispatch();
    const { adminProjects } = useSelector(state => state.adminStore);
    const [inputProjectData, setProjectData] = useState()


    useEffect(() => {
        dispatch(getAdminDashboardProjects())
    }, [dispatch])

    useEffect(() => {
        setProjectData(adminProjects)
    }, [adminProjects])


    return (
        <>
            <Header />
            <Sidebar/>
            <div id="main-content">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>Project Managment</h2>
                        </div>            
                        <div className="col-md-6 col-sm-12 text-right">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/"><i className="icon-home"></i></Link></li>
                                <li className="breadcrumb-item active">Project Managment</li>
                            </ul>
                            {/* <Link to="/admin/create-subadmin" className="btn btn-sm button" title="">Create New</Link> */}
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row clearfix">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="header">
                                    <h2>Projects </h2>
                                </div>
                                <div className="body py-1">
                                    <div className="table text-center">
                                        <DataTablesProject data={inputProjectData} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ActivitySchedule;